import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import {I18nProvider} from './i18n/I18nProvider'
import 'antd/dist/reset.css'
// 官网营销页令牌（--site-*），与业务系统令牌互不干扰，勿合并
import './components/site/styles/site-theme.css'
// 业务系统全局设计令牌（--pt-*），需在 dark-theme.css 之前加载
import './styles/tokens.css'
import './styles/dark-theme.css'
// 布局外壳与通用 UI 原子类（均依赖 --pt-* 令牌）
import './styles/layout-shell.css'
import './styles/pattern-ui.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <I18nProvider>
            <App/>
        </I18nProvider>
    </React.StrictMode>,
)
